import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { GrokVideoEditorJsonLd } from '@/components/custom/grok-video-editor-json-ld';
import { GrokVideoEditorPage } from '@/components/custom/grok-video-editor-page';
import { getGrokVideoEditorSeoData } from '@/components/custom/grok-video-editor-seo-data';
import { seo } from '@/lib/seo';
import { getImageUrl } from '@/lib/urls';

const searchSchema = z.object({
  sourceVideoId: z.string().min(1).optional(),
});

export const Route = createFileRoute('/ai-video-editor')({
  validateSearch: searchSchema,
  head: () => {
    const data = getGrokVideoEditorSeoData();
    return seo(data.path, {
      title: data.seoTitle,
      description: data.seoDescription,
      keywords: data.keywords,
      image: getImageUrl(data.ogImage),
    });
  },
  component: GrokVideoEditorRoute,
});

function GrokVideoEditorRoute() {
  const search = Route.useSearch();

  return (
    <>
      <GrokVideoEditorPage initialSourceVideoId={search.sourceVideoId} />
      <GrokVideoEditorJsonLd />
    </>
  );
}
